<div>
  @if (toolName === AccessibilityAuditToolNames.access_engine && ruleDetails.hasAutomatedRemediation) {
    <ds-banner
      [state]="DsBannerState.info"
      [showTitle]="false"
      [showAction]="false"
      [showCloseButton]="true"
      data-test-id="finding-details-art-banner"
      class="d-block mb-3"
    >
      <div ds-banner-body>
        <p class="mb-0">
          {{ 'finding_details_art_banner_copy' | translate }}
          <ds-link [external]="true" href="https://client.levelaccess.com/hc/en-us/articles/31059428597143">
            {{ 'issues_table_automated_remediation_info_message_link_label' | translate }}
          </ds-link>
        </p>
      </div>
    </ds-banner>
  }

  @if (isFindingsDetailsRefreshEnabled()) {
    <app-issues-view-details-base
      [issue]="issue"
      [scanId]="scanId"
      [ruleDetails]="ruleDetails"
      [toolName]="toolName"
      [whereIsItLocated]="whereIsItLocatedText()"
      [whereIsItLocatedUrl]="whereIsItLocatedUrl()"
      [mainContentBlocks]="mainContentBlocks()"
      (dismissFinding)="dismissFinding.emit()"
      (restoreFinding)="restoreFinding.emit()"
      (createTask)="createTask.emit()"
      (navigatedAway)="navigatedAway.emit()"
    >
      <ng-container finding-content-additional>
        @if (isColorContrastRule(issue)) {
          <button (click)="openColorContrastModal()" type="button" class="btn btn-link p-0 fw-bold">
            {{ 'contrast_finder' | translate }}
          </button>
        }
        @if (isElementFromShadowDom) {
          <div
            class="info-banner alert alert-primary w-100 d-flex align-items-center margin-bottom"
            data-test-id="element-is-from-shadow-dom"
          >
            <ds-icon class="margin-right-sm icon-info" [icon]="Icons.CircleInfo" [iconStyle]="IconStyles.Regular"></ds-icon>
            {{ 'finding_in_shadow_dom' | translate }}
          </div>
        }
        @if (isElementFromIframe) {
          <div
            class="info-banner alert alert-primary w-100 d-flex align-items-center margin-bottom"
            data-test-id="element-is-from-iframe"
          >
            <ds-icon class="margin-right-sm icon-info" [icon]="Icons.CircleInfo" [iconStyle]="IconStyles.Regular"></ds-icon>
            {{ 'finding_in_iframe' | translate }}
          </div>
        }
      </ng-container>
    </app-issues-view-details-base>
  } @else {
    <div class="margin-bottom">
      @if (isDigitalAssetFindingsEnabled) {
        <div class="margin-bottom">
          <label class="label margin-bottom-xs">{{ 'finding_id' | translate }}</label>
          <div data-test-id="finding-id">{{ issue.issueId }}</div>
        </div>
      }
      @switch (toolName) {
        @case (AccessibilityAuditToolNames.ibm) {
          <label class="label margin-bottom-xs">{{ 'label_what_the_problem' | translate }}</label>
          <div
            [appHighlight]="issue.data.actualResult"
            [type]="'html'"
            class="margin-bottom-sm"
            data-test-id="what-is-the-problem"
          ></div>
        }
        @case (AccessibilityAuditToolNames.wave) {}
        @default {
          <label class="label margin-bottom-xs">{{ 'label_what_the_problem' | translate }}</label>
          <div [innerHTML]="issue.data.actualResult" class="margin-bottom-sm" data-test-id="what-is-the-problem"></div>
        }
      }

      @if (isColorContrastRule(issue)) {
        <button (click)="openColorContrastModal()" type="button" class="btn btn-link p-0 fw-bold">
          {{ 'contrast_finder' | translate }}
        </button>
      }
    </div>

    <div class="margin-bottom">
      <label class="label margin-bottom-xs">{{ 'label_where_is_it_located' | translate }}</label>
      <div data-test-id="where-it-is-located">
        @if (isMobileType$ | async) {
          {{ issue.title }} - {{ issue.url }}
        } @else {
          {{ issue.title }} - <ds-link [external]="true" [href]="issue.url">{{ issue.url }}</ds-link>
        }
      </div>
    </div>

    @if ((isMobileType$ | async) === false) {
      <div class="margin-bottom">
        <label class="label margin-bottom-xs">{{ 'component_name' | translate }}</label>
        <div data-test-id="component-data">
          {{ getFlawComponentName() }}
        </div>
      </div>
    }

    @if (isElementFromShadowDom) {
      <div
        class="info-banner alert alert-primary w-100 d-flex align-items-center margin-bottom"
        data-test-id="element-is-from-shadow-dom"
      >
        <ds-icon class="margin-right-sm icon-info" [icon]="Icons.CircleInfo" [iconStyle]="IconStyles.Regular"></ds-icon>
        {{ 'finding_in_shadow_dom' | translate }}
      </div>
    }
    @if (isElementFromIframe) {
      <div
        class="info-banner alert alert-primary w-100 d-flex align-items-center margin-bottom"
        data-test-id="element-is-from-iframe"
      >
        <ds-icon class="margin-right-sm icon-info" [icon]="Icons.CircleInfo" [iconStyle]="IconStyles.Regular"></ds-icon>
        {{ 'finding_in_iframe' | translate }}
      </div>
    }
    @if (issue.data.elementReference?.trim()?.length > 0) {
      <div class="margin-bottom">
        <div class="margin-bottom-xs d-flex align-items-center justify-content-between">
          <span class="label" data-test-id="location-label">{{ locationLabel$ | async | translate }}:</span>
          <ds-copy [htmlIdToCopy]="selectorId"></ds-copy>
        </div>
        <pre><code data-test-id="selectorId" [id]="selectorId" class="d-block p-2" [appHighlight]="issue.data.elementReference" type="xquery"></code></pre>
      </div>
    }
    @if (issue.data.element) {
      <div class="margin-bottom">
        <div class="margin-bottom-xs d-flex align-items-center justify-content-between">
          <span class="label" data-test-id="element-label">{{ elementLabel$ | async | translate }}:</span>
          <ds-copy [htmlIdToCopy]="nodesHTMLId"></ds-copy>
        </div>
        <pre><code data-test-id="nodesHTMLId" [id]="nodesHTMLId" class="d-block p-2" [appHighlight]="issue.data.element" type="html"></code></pre>
      </div>
    }
    @if (displayIssueDescription()) {
      <div class="row margin-bottom">
        <div class="col-12">
          <label class="label margin-bottom-xs">{{ 'audit_rule_property_description' | translate }}</label>
          <div
            class="rule-description pre-line"
            [appHighlight]="displayIssueDescription()"
            [type]="'html'"
            data-test-id="description"
          ></div>
        </div>
      </div>
    }
    @if (ruleDetails[$scanIssues.whyItMatters]) {
      <div class="row margin-bottom">
        <div class="col-12">
          <label class="label margin-bottom-xs">{{ 'audit_rule_property_why_it_matters' | translate }}</label>
          @switch (toolName) {
            @case (AccessibilityAuditToolNames.access_engine) {
              <div
                class="rule-description pre-line"
                [innerHTML]="ruleDetails[$scanIssues.whyItMatters] | safeContent"
                data-test-id="why-it-matters"
              ></div>
            }
            @default {
              <div
                class="rule-description pre-line"
                [appHighlight]="ruleDetails[$scanIssues.whyItMatters]"
                [type]="'html'"
                data-test-id="why-it-matters"
              ></div>
            }
          }
        </div>
      </div>
    }
    @if (ruleDetails[$scanIssues.whatToDo]) {
      <div class="row margin-bottom">
        <div class="col-12">
          <label class="label margin-bottom-xs">{{ 'audit_rule_property_what_to_do' | translate }}</label>
          @switch (toolName) {
            @case (AccessibilityAuditToolNames.access_engine) {
              <div
                class="rule-description pre-line"
                [innerHTML]="ruleDetails[$scanIssues.whatToDo] | safeContent"
                data-test-id="what-to-do"
              ></div>
            }
            @default {
              <div
                class="rule-description pre-line"
                [appHighlight]="ruleDetails[$scanIssues.whatToDo]"
                type="html"
                data-test-id="what-to-do"
              ></div>
            }
          }
        </div>
      </div>
    }
    @if (issue._id) {
      <div class="row margin-bottom">
        <div class="col-12">
          <label class="label margin-bottom-xs">{{ 'findings_history_label' | translate }}</label>
          <div class="rule-description pre-line" data-test-id="first-seen">
            {{ 'finding_first_seen_label' | translate }} {{ issue[$flaw.firstFound].date | prettifyDate }}
          </div>
          <div class="rule-description pre-line" data-test-id="last-seen">
            {{ 'finding_last_seen_label' | translate }} {{ issue[$flaw.lastFound].date | prettifyDate }}
          </div>
          <div class="rule-description pre-line" data-test-id="previous-status">
            {{ 'finding_previous_status_label' | translate }} "{{ 'label_' + getFlawPreviousStatus() | translate }}"
          </div>
          <div class="rule-description pre-line" data-test-id="times-seen">
            {{ 'finding_times_seen_label' | translate }} {{ issue.flawOccurrence }}
          </div>
        </div>
      </div>
    }
    <div class="margin-bottom">
      <app-share-issue-report-url [url]="url"></app-share-issue-report-url>
    </div>
  }
</div>
